import React, { Component } from 'react';
import './Accordion.css';

class Accordion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    toggleAccordion = () => {
        this.setState(prevState => ({
            isOpen: !prevState.isOpen,
        }));
    };

    render() {
        const { title, children } = this.props;
        const { isOpen } = this.state;

        return (
            <div className="accordion-section">
                <button className="accordion-header" onClick={this.toggleAccordion}>
                    <span className="accordion-title">{title}</span>
                    <span className="accordion-icon">{isOpen ? '-' : '+'}</span>
                </button>
                {isOpen && (
                    <div className="accordion-content">
                        {children}
                    </div>
                )}
            </div>
        );
    }
}

export default Accordion;